var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("common-content", { attrs: { id: "culture" } }, [
    _c("div", { staticClass: "culture-content", style: _vm.up }, [
      _c("div", { staticClass: "culture-title" }, [
        _c("p", { staticClass: "common-title_tit" }, [
          _c("img", {
            attrs: {
              src: "http://cdn.dongliyuanlin.com/culture-text.png",
              alt: "发现美 创造美"
            }
          })
        ]),
        _c("p", { staticClass: "common-title_des" }, [
          _vm._v(_vm._s(_vm.pageData[0].content))
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-49ae6508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49ae6508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/culture/index.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-49ae6508","hasScoped":false,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./pages/culture/index.vue
// module chunks = 0